var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"mb-4",attrs:{"variant":"secondary"},on:{"click":_vm.back}},[_c('b-icon',{attrs:{"icon":"arrow-left"}}),_vm._v(" 戻る ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }